/**
 * Turn what somebody typed into E.164, which is what the kernel stores on a
 * Person's phones and on a Message's numbers. Returns null when it cannot be
 * made into one, rather than guessing.
 *
 * A bare 10-digit number is read as North American (+1); anything else needs
 * its country code, and the form says so.
 */
export function toE164(raw) {
  const s = String(raw || "").trim();
  if (!s) return null;
  const plus = s.startsWith("+");
  let digits = s.replace(/\D/g, "");
  if (!plus) {
    if (digits.startsWith("00")) digits = digits.slice(2);
    else if (digits.length === 10) digits = "1" + digits;
    else if (!(digits.length === 11 && digits.startsWith("1"))) return null;
  }
  const e = "+" + digits;
  return /^\+[1-9]\d{7,14}$/.test(e) ? e : null;
}

/**
 * Format an E.164 number for display. North American (+1) numbers are shown
 * as "+1 (XXX) XXX-XXXX"; anything else is returned unchanged rather than
 * guessing at a foreign format.
 */
export function formatPhone(raw) {
  if (!raw) return raw;
  const s = String(raw);
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(s);
  if (m) return `+1 (${m[1]}) ${m[2]}-${m[3]}`;
  return s;
}
